import React from "react";
import {Stack, Typography, Button, Tabs, Tab} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Flag from "@mui/icons-material/Flag";
import {FeatureFlag} from "../../../types/domain/featureFlag";

interface FeatureFlagsListProps {
    featureFlags: FeatureFlag[];
    t: (key: string) => string;
    selectedTab: string;
    setAddFeatureFlagDialogVisible: (visible: boolean) => void;
    featureFlagSelect: (featureFlag: FeatureFlag) => void;
}

const FeatureFlagsList: React.FC<FeatureFlagsListProps> = ({
    featureFlags,
    t,
    selectedTab,
    setAddFeatureFlagDialogVisible,
    featureFlagSelect,
}) => {
    return (
        <Stack
            direction="column"
            sx={{height: "calc(100% - 2.25rem)", padding: "1.125rem", minWidth: "330px", maxWidth: "330px"}}
            overflow="hidden"
            gap="1.5rem"
        >
            <Typography color="primary" fontSize={22}>
                {t("feature_flags_page.title")}
            </Typography>
            <Stack
                direction="column"
                gap="1rem"
                sx={{backgroundColor: "background.default", paddingTop: "1rem", paddingRight: "1rem"}}
            >
                <Button
                    sx={{whiteSpace: "nowrap", marginLeft: "auto"}}
                    startIcon={<AddIcon />}
                    onClick={() => {
                        setAddFeatureFlagDialogVisible(true);
                    }}
                >
                    {t("feature_flags_page.add_feature_flag")}
                </Button>
                <Tabs
                    value={selectedTab}
                    orientation="vertical"
                    textColor="inherit"
                    variant="fullWidth"
                    TabIndicatorProps={{
                        sx: {
                            width: "3px",
                            left: 0,
                        },
                    }}
                    sx={{
                        bgcolor: "background.default",
                        minHeight: "auto",
                        color: "#000000A0",
                        "& .Mui-selected": {color: "primary.main"},
                    }}
                >
                    {featureFlags.map((featureFlag) => (
                        <Tab
                            color="primary"
                            key={featureFlag.name}
                            label={
                                <Typography
                                    noWrap
                                    sx={{
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                    }}
                                    title={featureFlag?.name}
                                >
                                    {featureFlag?.name}
                                </Typography>
                            }
                            icon={<Flag />}
                            iconPosition="start"
                            value={featureFlag.name}
                            onClick={() => featureFlagSelect(featureFlag)}
                            sx={{
                                minHeight: "3rem",
                                height: "3rem",
                                justifyContent: "left",
                                paddingX: "1.25rem",
                                opacity: 1,
                                fontSize: "14px",
                                lineHeight: "1.25rem",
                            }}
                        />
                    ))}
                </Tabs>
            </Stack>
        </Stack>
    );
};

export default FeatureFlagsList;
